import {registerTourSteps} from './product-tours.js'

// Walk-through of the Nurse Onboarding checklist. Launched through the shared registry in
// product-tours.js: automatically the first time a nurse opens the page (the server marks the
// page root with `data-onboarding-auto-tour`), from the Tours & Guides drawer, or from a
// `#cpm-tour=nurse_onboarding_checklist` link. It is a guide to the page, not an onboarding step.
export const NURSE_ONBOARDING_TOUR_ID = 'nurse_onboarding_checklist'
const ROOT_SELECTOR = '[data-tour="onboarding-checklist"]'

export function nurseOnboardingTourSteps(documentObject) {
    if (!documentObject.querySelector(ROOT_SELECTOR)) {
        return {
            steps: [{
                selector: null,
                title: 'Open Nurse Onboarding first',
                text: 'This tour walks through the onboarding checklist. Open Nurse Onboarding from your account menu, then start it again from the tour list.',
            }],
            onEnd: null,
        }
    }

    const steps = [
        {
            selector: '[data-tour="onboarding-summary"]',
            position: 'bottom',
            title: 'Your place in onboarding',
            text: 'This line and bar show which step you are on and how much is done. Progress is saved as you go, so you can leave and come back. Steps open in order: a locked card tells you what to finish first.',
        },
        {
            selector: '[data-tour="onboarding-step-tours"]',
            position: 'top',
            title: 'Step 1: Nurse Essentials tours',
            text: 'Short guided tours of the CPM screens you will use every day. Start each one from here; it is marked complete when you reach the last step.',
        },
        {
            selector: '[data-tour="onboarding-step-documentation"]',
            position: 'top',
            title: 'Step 2: Documentation standards',
            text: 'Read how to write a note the next care team member can act on, then confirm you reviewed it.',
        },
        {
            selector: '[data-tour="onboarding-step-call-examples"]',
            position: 'top',
            title: 'Step 3: Call examples',
            text: 'Listen to the good and poor call recordings in Call Orientation, then confirm you reviewed them.',
        },
        {
            selector: '[data-tour="onboarding-step-simulations"]',
            position: 'top',
            title: 'Step 4: Simulated patient call',
            text: 'Call Margaret, an AI patient, from Call Orientation and write her visit note. Your call and note are reviewed together. You have three attempts.',
        },
        {
            selector: '[data-tour="onboarding-step-certificate"]',
            position: 'top',
            title: 'Step 5: Certificate and live patients',
            text: 'Issued automatically when the steps above are complete. It unlocks your live patient list and the call window, and you can download it as a PDF.',
        },
        {
            selector: '[data-tour="onboarding-step-compensation"]',
            position: 'top',
            title: 'Step 6: Training compensation',
            text: 'After certification, use Self-Assign Patients on your CPM home page to assign yourself patients from your practices. Once you save a successful call note for your first real patient, the training compensation is added to your invoice automatically. Nothing to submit.',
        },
    ]

    return {
        steps: steps.filter(step => documentObject.querySelector(step.selector)),
        onEnd: null,
    }
}

export function registerNurseOnboardingTour(browserWindow, documentObject) {
    registerTourSteps(NURSE_ONBOARDING_TOUR_ID, () => nurseOnboardingTourSteps(documentObject))

    const startIfDue = () => {
        const root = documentObject.querySelector(ROOT_SELECTOR)

        if (!root?.hasAttribute('data-onboarding-auto-tour') || /cpm-tour=/.test(browserWindow.location.hash)) {
            return
        }

        root.removeAttribute('data-onboarding-auto-tour')
        browserWindow.setTimeout(() => browserWindow.cpmStartTour?.(NURSE_ONBOARDING_TOUR_ID), 600)
    }

    documentObject.addEventListener('DOMContentLoaded', startIfDue)
    documentObject.addEventListener('livewire:navigated', startIfDue)
    startIfDue()
}
